import TransferStatusSection from './TransferStatusSection';

export default TransferStatusSection;
